import { render, staticRenderFns } from "./ViewEntityData.vue?vue&type=template&id=0a8337e2&scoped=true"
import script from "./ViewEntityData.vue?vue&type=script&lang=js"
export * from "./ViewEntityData.vue?vue&type=script&lang=js"
import style0 from "./ViewEntityData.vue?vue&type=style&index=0&id=0a8337e2&prod&lang=scss&scoped=true"
import style1 from "./ViewEntityData.vue?vue&type=style&index=1&id=0a8337e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a8337e2",
  null
  
)

export default component.exports